
import { defineComponent, provide, reactive, ref, onMounted, inject } from 'vue'
import { WindowState, incrMaxZindex } from './window'
import { ContainersState, useAutoLayout } from './window-container'
import { customPropsType } from '../util'

export default defineComponent({
  name: 'window-container-sidebar',
  props: {
    containerState: customPropsType<ContainersState>()
  },
  setup (props) {
    const windows = ref(new Array<WindowState>())
    const windowsListRef = ref<HTMLUListElement>()
    const blockRect = reactive({ width: 0, height: 0 })
    provide('window-size', blockRect)
    onMounted(() => {
      windows.value = inject<WindowState[]>('windows', [])
    })
    const pullWindow = (win: WindowState) => {
      win.zIndex = incrMaxZindex()
    }
    const autoLayout = () => {
      useAutoLayout(props.containerState)
    }
    return {
      windows,
      windowsListRef,
      pullWindow,
      autoLayout
    }
  }
})
